import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/auth'
import statuses from '@/store/statuses'
import classes from '@/store/classes'
import userTypes from '@/store/userTypes'
import orders from '@/store/orders'
import reports from '@/store/reports'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    statuses,
    classes,
    userTypes,
    orders,
    reports
  }
})
